import * as css from './SubscriptionsTable.css';
import Table from '../../../component/newTable/Table';
import SubscriptionRow from './subscriptionRow/SubscriptionRow';
import SubscriptionCard from './subscriptionCard/SubscriptionCard';
import {useContext, useRef} from 'react';
import {TableContextValue} from '../../components/tableContext/TableContext';
import {mobileMedia} from '../../../globalVariables/GlobalVariables';
import useMobile from '../../../hooks/useMobile';
import AnotherOneHorizontal from '../../../component/anotherOneHorizontal/AnotherOneHorizontal';
import {useTranslation} from 'react-i18next';
import CustomScrollbar from '../../../component/customScrollbar/CustomScrollbar';
import useTablet from '../../../hooks/useTablet';
import {SubscriptionPlan} from '../../../redux/subscription/subscription.type';
import AssigningEventsPop from '../components/assigningEventsPop/AssigningEventsPop';
import {seriesTypeLabel} from '../utils/subscriptionUtils';
import {usePlanPopupHandlers} from './usePlanPopupHandlers';
import DetailsPop from './detailsPop/DetailsPop';
import setGlobalState from '../../../redux/setGlobalState';

function SubscriptionsTable({isCardView = false}: {isCardView?: boolean}) {
    const {searchArray} = useContext(TableContextValue);
    const isMobile = useMobile();
    const isTablet = useTablet();
    const effectiveCardView = isTablet ? true : isCardView;
    const {handleOpenDetails, handleOpenAssigningEvents, detailsPopShow, assigningEventsShow, selectedPlan, handleCloseDetails, handleCloseAssigningEvents} = usePlanPopupHandlers();
    const {t} = useTranslation('subscriptions');
    const contentRef = useRef(null);
    const handleNewSubscription = () => {
        setGlobalState('ui.show.isOpenCreateSubscription', true);
    };

    const cssStyle = `
        top: 20px;
        inset-inline-end: -40px;
        ${mobileMedia}{
            display: none;
        }
    `;
    
    return (
        <>
            <CustomScrollbar contentRef={contentRef} cssStyle={cssStyle} />
            <css.wrapper data-cy="subscriptionsTable" isCardView={effectiveCardView} ref={contentRef}>
                {effectiveCardView ? ( 
                    <css.cardsGrid>
                        {searchArray?.map((plan: SubscriptionPlan) => (
                            <SubscriptionCard 
                                key={plan.planTid} 
                                plan={plan}
                                onOpenDetails={handleOpenDetails}
                                onOpenAssigningEvents={handleOpenAssigningEvents}
                            />
                        ))}
                        {!isMobile && <AnotherOneHorizontal 
                            title={t('newSeries')}
                            onClick={handleNewSubscription}
                            width={'100%'} height={'105px'}                            
                        ><></></AnotherOneHorizontal>}
                    </css.cardsGrid>
                ) : (
                    <Table
                        list={searchArray?.map((plan: SubscriptionPlan) => ({
                            comp: SubscriptionRow,
                            props: {plan, onOpenDetails: handleOpenDetails, onOpenAssigningEvents: handleOpenAssigningEvents},
                            key: plan.planTid
                        }))}
                        customScrollbar={{cssStyle}} checked={undefined} buttonsChildren={undefined} searchProps={undefined}
                    />
                )}
            </css.wrapper>
            {assigningEventsShow.isOpen && selectedPlan && (
                <AssigningEventsPop
                    show={assigningEventsShow}
                    onClose={handleCloseAssigningEvents}
                    planTid={selectedPlan.planTid}
                    subscriptionTitle={selectedPlan.title}
                    subscriptionSubtitle={t(seriesTypeLabel[selectedPlan.planType]?.label)}
                />
            )}
            {detailsPopShow.isOpen && selectedPlan && (
                <DetailsPop
                    plan={selectedPlan}
                    detailsPopShow={detailsPopShow}
                    onCloseDetails={handleCloseDetails}
                    onOpenAssigningEvents={handleOpenAssigningEvents}
                />
            )}
        </>
    );
}

export default SubscriptionsTable;
